import { useState, useEffect, useCallback } from "react";

const CHECK_INTERVAL = 60_000; // every 60s

export function useUpdateCheck() {
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const [initialHash, setInitialHash] = useState<string | null>(null);

  const getHash = useCallback(async (): Promise<string | null> => {
    try {
      const res = await fetch("/?_vc=" + Date.now(), { cache: "no-store" });
      const html = await res.text();
      // Extract script src hashes which change on every build
      const scripts = html.match(/src="[^"]*\.js"/g);
      return scripts ? scripts.join(",") : null;
    } catch {
      return null;
    }
  }, []);

  useEffect(() => {
    getHash().then((h) => {
      if (h) setInitialHash(h);
    });
  }, [getHash]);

  useEffect(() => {
    if (!initialHash) return;

    const interval = setInterval(async () => {
      const currentHash = await getHash();
      if (currentHash && currentHash !== initialHash) {
        setUpdateAvailable(true);
        clearInterval(interval);
      }
    }, CHECK_INTERVAL);

    return () => clearInterval(interval);
  }, [initialHash, getHash]);

  const refresh = useCallback(() => {
    window.location.reload();
  }, []);

  const dismiss = useCallback(() => {
    setUpdateAvailable(false);
  }, []);

  return { updateAvailable, refresh, dismiss };
}
